import { LogoMarquee } from '@/features/landing-page/v3/sections/logo-marquee'

/**
 * lp-v3 "backed by" logos section — a caption over the shared logo marquee (24px logos). Its own
 * vertical padding gives the band breathing room between the two viewport-height cards (hero above,
 * vision below), whose padding was tightened for the full-height fit. `!` overrides the `.ds2` heading.
 */
export function LpLogosSection() {
    return (
        <section className="w-full overflow-hidden py-[40px] md:py-[64px]">
            <div className="space-y-6">
                <h2 className="text-center text-[16px]! font-normal! leading-[1.2]! tracking-normal! text-muted-foreground">
                    Backed by leading investors & companies
                </h2>

                <LogoMarquee logoHeightClass="max-h-6" gapPx={100} />
            </div>
        </section>
    )
}
